import React from 'react';
import * as XLSX from 'xlsx';
function convertArrayOfObjectsToXLSX(array) {
    const translate = [
      {
        key: '_id',
        name: ['ID']
      },
      {
        key: 'createdAt',
        name: ['Creado el']
      },
      {
        key: 'finishedAt',
        name: ['Finalizado el']
      },
      {
        key: 'reminder',
        name: ['Recordatorio']
      },
      {
        key: 'type',
        name: ['Tipo']
      },
      {
        key: 'completed',
        name: ['Completado']
      }
    ];
  
    const result = [];
  
    // Crear la primera fila con los nombres de las columnas
    let firstRow = [];
    translate.forEach(({ name }) => {
      firstRow = [...firstRow, ...name];
    });
    result.push(firstRow);
  
    // Procesar los datos
    array.forEach(item => {
      const temp = [];
      translate.forEach(({ key }) => {
        // Función para obtener el valor de la propiedad de manera recursiva
        const getValue = (obj, path) =>
          path.split('.').reduce((acc, part) => acc && acc[part], obj);
  
        // Obtener el valor de la propiedad y agregarlo al array
        const value = getValue(item, key);
        temp.push(value !== undefined ? value : ''); // Si el valor es undefined, usar cadena vacía
      });
  
      // Obtener las preguntas del formulario
      if (item.leadForm && Array.isArray(item.leadForm)) {
        item.leadForm.forEach(formItem => {
          temp.push(formItem.form[0].question || '');
          temp.push(formItem.response || '');
        });
      } else {
        // Si no hay formularios, agregar celdas vacías para las preguntas y respuestas
        temp.push('');
        temp.push('');
      }
  
      // Obtener información de los amigos
      if (item.leadFriends && Array.isArray(item.leadFriends)) {
        item.leadFriends.forEach(friendItem => {
          temp.push(friendItem.fullName || '');
          temp.push(friendItem.email || '');
          temp.push(friendItem.status || '');
          temp.push(friendItem.response || '');
        });
      } else {
        // Si no hay amigos, agregar celdas vacías para la información del amigo
        temp.push('');
        temp.push('');
        temp.push('');
        temp.push('');
      }

       // Obtener las preguntas del formulario
       if (item.leadList && Array.isArray(item.leadList)) {
        item.leadList.forEach(formItem => {          
          temp.push(formItem || '');
        });
      } else {
        // Si no hay formularios, agregar celdas vacías para las preguntas y respuestas
        temp.push('');
        temp.push('');
      }
  
      result.push(temp);
    });
  
    return result;
  }
  
function DownloadButton({ dataArray, fileName }) {
  const handleDownload = () => {
    const workbook = XLSX.utils.book_new();
    const data = convertArrayOfObjectsToXLSX(dataArray);

    if (data === null) return;

    const worksheet = XLSX.utils.aoa_to_sheet(data);
    workbook.SheetNames.push('First');
    workbook.Sheets['First'] = worksheet;
    const xlsbin = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'binary'
    });

    const buffer = new ArrayBuffer(xlsbin.length);
    const array2 = new Uint8Array(buffer);
    for (let i = 0; i < xlsbin.length; i++) {
      array2[i] = xlsbin.charCodeAt(i) & 0xff;
    }

    const xlsblob = new Blob([buffer], { type: 'application/octet-stream' });
    const url = URL.createObjectURL(xlsblob);

    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = fileName || 'data.xlsx';
    anchor.click();
  };

  return (
    <button
      onClick={handleDownload}
      style={{
        width: '205px',
        height: '41px',
        background:
          '0% 0% no-repeat padding-box padding-box rgb(115, 103, 240)',
        borderRadius: '5px',
        textAlign: 'center',
        font: 'bold 13px / 41px Geist',
        letterSpacing: '0px',
        color: 'rgb(255, 255, 255)',
        border: 'none',
        marginTop: '35px',
        marginRight: '35px'
      }}
    >
      Descargar respuestas
    </button>
  );
}

export default DownloadButton;
